import PropTypes from 'prop-types';
import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

const IconChevronUp = ({ className, stroke = 'currentColor' }) => {
    return (
        <svg
            className={'icon-chevron-up' + (className ? ` ${className}` : '')}
            fill='none'
            height='20'
            width='20'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='m3.64636 13.1612 6.34315-6.34316 6.36409 6.36406'
                stroke={stroke}
                strokeLinecap='round'/>
        </svg>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    stroke: PropTypes.string,
    className: PropTypes.string
};

IconChevronUp.propTypes = propTypes;

export default IconChevronUp;
